export default __webpack_public_path__ + "static/media/ParkingYard.787823fd.svg";